<template>
    <div class="t-lk-tags">
        <div class="t-lk-tags__container">
            <div
                v-if="isAll"
                class="t-lk-tags__item"
                :class="{ _active: !$route.query[idTags] }"
                @click="deleteTags()"
            >
                <span class="t-lk-tags__name">{{ allName }}</span>
            </div>
            <div
                v-for="(item, index) in tags"
                class="t-lk-tags__item"
                :key="'lk-tags-item-' + index"
                :class="{ _active: checked[index] === item.id }"
                @click="toggleTags(index, item.id)"
            >
                <span class="t-lk-tags__name">{{ item.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tags: Array,
            isAll: {
                type: Boolean,
                default: false
            },
            allName: String,
        },
        data() {
            return {
                checked: [],
                idTags: 'tags',
            };
        },
        methods: {
            deleteTags() {
                this.checked = [];
                this.routerPush();
            },
            toggleTags(index, id) {
                if (this.checked[index]) {
                    this.$set(this.checked, index, undefined);
                } else {
                    this.$set(this.checked, index, id);
                }
                this.routerPush();
            },
            routerPush() {
                let query = {tags: this.checked.filter((item) => {return item !== undefined;}).join(',')};
                if (!query.tags) {
                    query = { tags: undefined };
                }
                // this.$root.setDataAnimateFalse();
                this.$router.push({
                    name: this.$route.name,
                    query: Object.assign(
                        {},
                        this.$route.query,
                        {
                            loadMore: undefined,
                            currentPage: undefined,
                        },
                        query
                    ),
                })
                .catch((err) => {});
            },
        },
        created() {

        },
        mounted() {
            this.tags.forEach((item) => {
                if (this.$route.query[this.idTags]) {
                    this.checked.push(
                        this.$route.query[this.idTags].indexOf(item.id) > -1
                            ? item.id
                            : undefined
                    );
                }
            });
        },
    };
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-tags/lk-tags.vue